import { defineEvents, SHARED_EVENTS } from '@3plearning/mx-teacher-analytics';

const ASSIGNMENT = 'assignment';
const SWITCH = 'switch';
const FILTERS = 'filters';
const UI = 'ui';
const MENU = 'menu';
const ACCESS = 'access';
const ACTIVITY = 'activity';
const STUDENT = 'student';

const appEvents = defineEvents({
  ...SHARED_EVENTS,
  'assignment.flow-started': { group: ASSIGNMENT, props: {} },
  'assignment.confirmation': { group: ASSIGNMENT, props: {} },
  'switch.to-old-assign': { group: SWITCH, props: {} },
  'filter.class-changed': { group: FILTERS, props: {} },
  'filter.group-changed': { group: FILTERS, props: {} },
  'filter.topic-applied': { group: FILTERS, props: {} },
  'ui.how-it-works': { group: UI, props: {} },
  'ui.view-key': { group: UI, props: {} },
  'menu.action': { group: MENU, props: {} },
  'access.changed': { group: ACCESS, props: {} },
  'activity.preview': { group: ACTIVITY, props: {} },
  'activity.teacher-notes': { group: ACTIVITY, props: {} },
  'student.menu': { group: STUDENT, props: {} }
});

export default appEvents;



// WEBPACK FOOTER //
// ./analytics/client/events.js